import { render } from "./IntegrationConfirmDialog.vue?vue&type=template&id=b8169318"
import script from "./IntegrationConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./IntegrationConfirmDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script